<template>
	<router-link
		v-if="isExternal"
		tag="section"
		:to="brandBuilderHome"
		@click.native="externalLink()"
		class="highlight-card"
		:style="{ 'background-image': 'url(' + backgroundImage + ')' }"
	>
		<article class="card-content">
			<span class="icon">
				<font-awesome-icon :icon="[iconWeight, icon]" />
			</span>
			<div class="title">{{ title }}</div>
			<div class="description">{{ description }}</div>
		</article>
	</router-link>
	<router-link
		v-else
		tag="section"
		:to="route"
		class="highlight-card"
		:style="{ 'background-image': 'url(' + backgroundImage + ')' }"
	>
		<article class="card-content">
			<span class="icon">
				<font-awesome-icon :icon="[iconWeight, icon]" />
			</span>
			<div class="title">{{ title }}</div>
			<div class="description">{{ description }}</div>
		</article>
	</router-link>
</template>

<script>
export default {
	name: 'HighlightCard',
	props: {
		icon: String,
		iconWeight: String,
		title: String,
		description: String,
		backgroundImage: String,
		route: String,
	},
	data() {
		return {
			brandBuilderHome: '/campaign-editor-home/campaign-editor-overview',
		};
	},
	computed: {
		isExternal() {
			const external = 'https://';
			return this.route.startsWith(external);
		},
	},
	methods: {
		externalLink() {
			window.open(this.route, '_blank');
		},
	},
};
</script>

<style lang="scss" scoped>
.highlight-card {
	@include rem(max-width, 430px);
	width: 100%;
	margin: 0 1px;
	color: $white;
	max-width: 430px;
	cursor: pointer;
	background-size: cover;
	white-space: unset;

	&:before,
	&:after {
		content: '';
		display: inline-block;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 1;
	}

	&:before {
		background: linear-gradient(transparent, 50%, #000);
		opacity: 0;
		transition: opacity $b360-motion-duration--longest
			$b360-motion-easing--standard;
	}

	&:after {
		background: linear-gradient(transparent, 70%, #000);
		opacity: 1;
		transition: opacity $b360-motion-duration--longest
			$b360-motion-easing--standard;
	}

	&:hover {
		&::before {
			opacity: 1;
		}

		&::after {
			opacity: 0;
		}
	}
}

a.highlight-card.swiper-slide {
	color: $white;
	text-decoration: none;
}

.card-content {
	display: flex;
	justify-content: flex-end;
	flex-direction: column;
	height: 260px;
	margin-left: 20px;
	position: relative;
}

.icon,
.title,
.description {
	z-index: 5;
}

.icon {
	@include rem(font-size, 28px);
	font-weight: 300;
}
.title {
	@include typo--roboto__bold;
	@include rem(font-size, 15px);
}
.description {
	@include typo--roboto__regular;
	@include rem(font-size, 26px);
	margin-bottom: 20px;
}
</style>
